<template>
    <div class="row page-height">
        <div class="col-12">
            <h4 v-if="this.editMode" class="page-title text-truncate">
                {{ $t('Provider.EditProvider') }}
            </h4>
            <h4 v-if="!this.editMode" class="page-title text-truncate">
                {{ $t('Provider.AddProvider') }}
            </h4>

            <b-row>
                <b-col md="12" sm="12" lg="12">
                    <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false">
                        <div
                            class="tab-content tab-content-custom-pill"
                            id="pills-tabContent-custom"
                        >
                            <div class="tab-pane fade show active" id="general" role="tabpanel">
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.Code')"
                                            v-bind:Name="'Code'"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="15"
                                            v-model="provider.code"
                                            v-bind:isRequired="true"
                                            v-bind:isReadOnly="isReadOnly || editMode"
                                            v-bind:Id="'input_code'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('insuranceSetup.CompanyName')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="50"
                                            v-bind:Name="'companyName'"
                                            v-model="provider.company"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_company'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$tc('Contact.Contact')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="50"
                                            v-bind:Name="'contact'"
                                            v-model="provider.contact"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_contact'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('Shared.Status')"
                                            v-bind:Options="StatusOptions"
                                            v-bind:FieldDescription="'name'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Model="provider.status"
                                            v-bind:Multiple="false"
                                            :IsDisabled="isReadOnly"
                                            :Input="ChangeDropDownStatus"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.FirstName')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="50"
                                            v-bind:Name="'firstName'"
                                            v-model="provider.firstName"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_firstName'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.Initial')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="10"
                                            v-bind:Name="'initial'"
                                            v-model="provider.initial"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_initial'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.Phone')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="15"
                                            v-bind:Name="'phone'"
                                            v-model="provider.telephone"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_telephone'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Patient.LegalFax')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="50"
                                            v-bind:Name="'fax'"
                                            v-model="provider.fax"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_fax'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.Email')"
                                            v-bind:TypeProp="'email'"
                                            v-bind:Name="'email'"
                                            v-model="provider.email"
                                            v-bind:isValid="isEmailValid"
                                            v-bind:Id="'input_insu_email'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.Address1')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="50"
                                            v-bind:Name="'address1'"
                                            v-model="provider.address1"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_addrs1'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.Address2')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="50"
                                            v-bind:Name="'address2'"
                                            v-model="provider.address2"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_addrs2'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.District')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="50"
                                            v-bind:Name="'district'"
                                            v-model="provider.district"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_district'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('Shared.Country')"
                                            v-bind:Options="CountryList"
                                            v-bind:FieldDescription="'name'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Model="CountryModel"
                                            v-bind:Tag="'Country'"
                                            v-bind:Multiple="false"
                                            :IsDisabled="isReadOnly"
                                            :Input="ChangeDropDownCountry"
                                        />
                                    </b-col>
                                    <b-col
                                        lg="3"
                                        md="3"
                                        sm="12"
                                        v-if="
                                            this.$store.state.companies.Country ===
                                                'United States' && isCountryUsa
                                        "
                                    >
                                        <MdSelect
                                            v-bind:Label="$t('Shared.State')"
                                            v-bind:Options="StateList"
                                            v-bind:FieldDescription="'name'"
                                            v-bind:FieldCode="'state'"
                                            v-bind:Model="provider.state"
                                            v-bind:Tag="'State'"
                                            v-bind:Multiple="false"
                                            :IsDisabled="isReadOnly"
                                            :Input="ChangeDropDownState"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12" v-else>
                                        <MdEdit
                                            v-bind:Label="$t('Shared.State')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:Name="'state'"
                                            v-bind:MaxLengthProp="20"
                                            v-model="provider.state"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_contact_state'"
                                        >
                                        </MdEdit>
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.City')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="50"
                                            v-bind:Name="'city'"
                                            v-model="provider.city"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_city'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.Zip')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="50"
                                            v-bind:Name="'zip'"
                                            v-model="provider.zip"
                                            v-on:blur="insuranceZipBlur(provider.zip)"
                                            v-on:change="insuranceZipChange($event)"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_zip'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdLookup
                                            v-bind:ModelCode="provider.taxonomy"
                                            v-bind:ModelDescription="taxonomyDescription"
                                            v-bind:Label="$t('Shared.Taxonomy')"
                                            v-bind:RefCode="'taxonomy'"
                                            v-bind:Fields="BaseFieldsComm"
                                            v-bind:Api="'GlobalCodes?CodeType=TAXONOMY'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:IsDisabled="false"
                                            v-bind:FieldDescription="'description'"
                                            :SearchTitle="$t('Shared.Taxonomy')"
                                            :GetValues="onCodeConditionOk"
                                            :InvalidFeedback="$t('employee.InvTaxCodeMsg')"
                                            :SearchFieldCode="'Code'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdLookup
                                            v-bind:ModelCode="provider.posCode"
                                            v-bind:ModelDescription="PosDescription"
                                            v-bind:Label="$t('PatientClaimList.Pos')"
                                            v-bind:RefCode="'posCode'"
                                            v-bind:Api="'PlaceOfServices'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:FieldDescription="'description'"
                                            :IsDisabled="isReadOnly"
                                            :SearchTitle="$t('PatientClaimList.Pos')"
                                            :GetValues="onCodeConditionOk"
                                            :SearchFieldCode="'code'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Tob')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="10"
                                            v-bind:Name="'TypeOfBill'"
                                            v-model="provider.typeOfBill"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_tob'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('Provider.typeOfPro')"
                                            v-bind:Options="typeProv"
                                            v-bind:FieldDescription="'name'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Model="provider.types"
                                            v-bind:Multiple="false"
                                            :IsDisabled="isReadOnly"
                                            :Input="ChangeDropDownType"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdLookup
                                            v-bind:ModelCode="provider.serviceLocation"
                                            v-bind:ModelDescription="slDescription"
                                            v-bind:Label="$t('Patient.ServiceLocation')"
                                            v-bind:RefCode="'serviceLocation'"
                                            v-bind:Api="'ProviderCodes/HealthcareServiceLocation'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Fields="BaseFieldsComm"
                                            v-bind:FieldDescription="'description'"
                                            :IsDisabled="isReadOnly"
                                            :SearchTitle="$t('Patient.ServiceLocation')"
                                            :GetValues="onCodeConditionOk"
                                            :SearchFieldCode="'code'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.DisplayName')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="50"
                                            v-bind:Name="'displayName'"
                                            v-model="provider.displayName"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_displayName'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Provider.DbName')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="50"
                                            v-bind:Name="'databaseName'"
                                            v-model="provider.databaseName"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_databaseName'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('Shared.TimeZone')"
                                            v-bind:Options="timeZoneList"
                                            v-bind:FieldDescription="'timeZone'"
                                            v-bind:FieldCode="'recId'"
                                            v-bind:Model="provider.timeZone"
                                            v-bind:Multiple="false"
                                            :IsDisabled="isReadOnly"
                                            :Input="ChangeDropDownZone"
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                            <div class="tab-pane fade" id="ref" role="tabpanel">
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.notMin')"
                                            v-bind:Name="'TimeInterval'"
                                            v-bind:TypeProp="'number'"
                                            v-model="provider.timeInterval"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Min="'0'"
                                            v-bind:StepProp="'1'"
                                            v-bind:Max="'10'"
                                            v-bind:Id="'input_timeInterval'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.eINNumber')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="20"
                                            v-bind:Name="'Federal'"
                                            v-model="provider.federal"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_Federal'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('NPI')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="20"
                                            v-bind:Name="'Providerid'"
                                            v-model="provider.providerid"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_providerid'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('CLIA')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="20"
                                            v-bind:Name="'clia'"
                                            v-model="provider.clia"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_clia'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.siteId')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="20"
                                            v-bind:Name="'siteid'"
                                            v-model="provider.siteid"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_insu_siteid'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.accountNo')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="20"
                                            v-bind:Name="'Rmtproviderpath'"
                                            v-model="provider.rmtproviderpath"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_Rmtproviderpath'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.altComName')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="20"
                                            v-bind:Name="'Remarks'"
                                            v-model="provider.remarks"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_Remarks'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.minPCodeL')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="10"
                                            v-bind:Name="'Minpatientcodelen'"
                                            v-model="provider.minpatientcodelen"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_Minpatientcodelen'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('providerSetup.ePreference')"
                                            v-bind:Options="EditorList"
                                            v-bind:FieldDescription="'name'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Model="provider.editorType"
                                            v-bind:Multiple="false"
                                            :IsDisabled="isReadOnly"
                                            :Input="ChangeDropDownEditor"
                                        />
                                    </b-col>
                                </b-row>
                                <MdTitle
                                    v-bind:Text="''"
                                    v-bind:isSubtitle="true"
                                    v-bind:Name="'T_TitleSearch'"
                                />
                                <b-row>
                                    <b-col md="12" lg="12" sm="12">
                                        <MdCheckListBox2
                                            v-model="checkLists.Reference.selected"
                                            v-bind:Options="checkLists.Reference.options"
                                            v-bind:columnCount="4"
                                            v-bind:Tag="'Reference'"
                                            :textField="'description'"
                                            :valueField="'code'"
                                            :ShowSearchInput="true"
                                            :ShowSelectAll="true"
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                            <div class="tab-pane fade" id="provid" role="tabpanel">
                                 <providerPanel
                                    :insuranceList="insuranceList"
                                    :isReadOnly="isReadOnly"
                                    v-model="provider.providerCodesList"
                                >
                                </providerPanel>
                            </div>
                            <div class="tab-pane fade" id="pref" role="tabpanel">
                                <MdTitle
                                    v-bind:Text="$t('providerSetup.iPatAddrPos')"
                                    v-bind:isSubtitle="true"
                                    v-bind:Name="'T_TitleSearch'"
                                />
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdRadioGroup
                                            v-model="provider.addressPos"
                                            v-bind:Options="horizontalpositionOptions"
                                            v-bind:Name="'horizontalpositionOptions'"
                                            v-bind:isReadOnly="isReadOnly"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.Top')"
                                            v-bind:TypeProp="'number'"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Min="'0'"
                                            v-bind:StepProp="'1'"
                                            v-bind:Max="'10'"
                                            v-bind:Name="'AddressTop'"
                                            v-model="provider.addressTop"
                                            v-bind:Id="'input_AddressTop'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.Height')"
                                            v-bind:TypeProp="'number'"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Min="'0'"
                                            v-bind:StepProp="'1'"
                                            v-bind:Max="'10'"
                                            v-bind:Name="'AddressHeight'"
                                            v-model="provider.addressHeight"
                                            v-bind:Id="'input_AddressHeight'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.iTerm')"
                                            v-bind:Name="'InvoiceTerm'"
                                            v-bind:TypeProp="'number'"
                                            v-model="provider.invoiceTerm"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Min="'0'"
                                            v-bind:StepProp="'1'"
                                            v-bind:Max="'10'"
                                            v-bind:Id="'input_InvoiceTerm'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.mCheckP')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="50"
                                            v-bind:Name="'PayableTo'"
                                            v-model="provider.payableTo"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_PayableTo'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.dsearchB')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="20"
                                            v-bind:Name="'DefaultSearchBy'"
                                            v-model="provider.defaultSearchBy"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_DefaultSearchBy'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.wMonthAppo')"
                                            v-bind:Name="'CalendarPastMonths'"
                                            v-bind:TypeProp="'number'"
                                            v-model="provider.calendarPastMonths"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Min="'0'"
                                            v-bind:StepProp="'1'"
                                            v-bind:Max="'10'"
                                            v-bind:Id="'input_CalendarPastMonths'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.showIdleScreen')"
                                            v-bind:Name="'IdleTimeOut'"
                                            v-bind:TypeProp="'number'"
                                            v-model="provider.idleTimeOut"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Min="'0'"
                                            v-bind:StepProp="'1'"
                                            v-bind:Max="'10'"
                                            v-bind:Id="'input_IdleTimeOut'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.pShedDura')"
                                            v-bind:TypeProp="'number'"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Min="'0'"
                                            v-bind:StepProp="'1'"
                                            v-bind:Max="'10'"
                                            v-bind:Name="'ProgDuration'"
                                            v-model="provider.progDuration"
                                            v-bind:Id="'input_ProgDuration'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('providerSetup.offiT')"
                                            v-bind:Options="OfficeToolList"
                                            v-bind:FieldDescription="'name'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Model="provider.officeTool"
                                            v-bind:Multiple="false"
                                            :IsDisabled="isReadOnly"
                                            :Input="ChangeDropDownOfficeTool"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="
                                                $t('providerSetup.eDataRange')
                                            "
                                            v-bind:TypeProp="'number'"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Min="'0'"
                                            v-bind:StepProp="'1'"
                                            v-bind:Max="'10'"
                                            v-bind:Name="'EmployeeInboxDefaultDays'"
                                            v-model="provider.employeeInboxDefaultDays"
                                            v-bind:Id="'input_EmployeeInboxDefaultDays'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row class="groupingRow">
                                    <b-col lg="2" md="2" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('insuranceSetup.TopMg')"
                                             v-bind:TypeProp="'number'"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Min="'0'"
                                            v-bind:StepProp="'1'"
                                            v-bind:Max="'10'"
                                            v-bind:Name="'Ub04Top'"
                                            v-bind:MaxLengthProp="25"
                                            v-model="provider.ub04Top"
                                            v-bind:Id="'input_Ub04Top'"
                                        >
                                        </MdEdit>
                                    </b-col>
                                    <b-col lg="2" md="2" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('insuranceSetup.LeftMg')"
                                            v-bind:TypeProp="'number'"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Min="'0'"
                                            v-bind:StepProp="'1'"
                                            v-bind:Max="'10'"
                                            v-bind:Name="'Ub04Left'"
                                            v-bind:MaxLengthProp="20"
                                            v-model="provider.ub04Left"
                                            v-bind:Id="'input_Ub04Left'"
                                        >
                                        </MdEdit>
                                    </b-col>
                                </b-row>
                                <b-row class="groupingRow">
                                    <b-col lg="2" md="2" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('insuranceSetup.TopMg')"
                                            v-bind:TypeProp="'number'"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Min="'0'"
                                            v-bind:StepProp="'1'"
                                            v-bind:Max="'10'"
                                            v-bind:Name="'Cms1500top'"
                                            v-bind:MaxLengthProp="25"
                                            v-model="provider.cms1500top"
                                            v-bind:Id="'input_Cms1500top'"
                                        >
                                        </MdEdit>
                                    </b-col>
                                    <b-col lg="2" md="2" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('insuranceSetup.LeftMg')"
                                            v-bind:TypeProp="'number'"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Min="'0'"
                                            v-bind:StepProp="'1'"
                                            v-bind:Max="'10'"
                                            v-bind:Name="'Cms1500Left'"
                                            v-bind:MaxLengthProp="20"
                                            v-model="provider.cms1500Left"
                                            v-bind:Id="'input_Cms1500Left'"
                                        >
                                        </MdEdit>
                                    </b-col>
                                   
                                </b-row>
                                <MdTitle
                                    v-bind:Text="$t('providerSetup.billingAddress')"
                                    v-bind:isSubtitle="true"
                                    v-bind:Name="'T_TitleSearch'"
                                />
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.Name')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="50"
                                            v-bind:Name="'BillingCompanyName'"
                                            v-model="provider.billingCompanyName"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_BillingCompanyName'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.Address1')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="100"
                                            v-bind:Name="'BillingAddress1'"
                                            v-model="provider.billingAddress1"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_BillingAddress1'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.Address2')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="100"
                                            v-bind:Name="'BillingAddress2'"
                                            v-model="provider.billingAddress2"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_BillingAddress2'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.City')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="100"
                                            v-bind:Name="'BillingCity'"
                                            v-model="provider.billingCity"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_BillingCity'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdLookup
                                            v-bind:ModelCode="provider.billingState"
                                            v-bind:ModelDescription="stateDescription"
                                            v-bind:Label="$t('Shared.State')"
                                            v-bind:RefCode="'state'"
                                            v-bind:Api="'States'"
                                            v-bind:FieldCode="'state'"
                                            v-bind:FieldDescription="'name'"
                                            :SearchTitle="$t('Shared.State')"
                                            :GetValues="onCodeConditionOk"
                                            :SearchFieldCode="'Code'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.Zip')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="100"
                                            v-bind:Name="'BillingZip'"
                                            v-model="provider.billingZip"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_BillingZip'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.Phone')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="15"
                                            v-bind:Name="'BillingTelephone'"
                                            v-model="provider.billingTelephone"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'BillingTelephone'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Patient.LegalFax')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="15"
                                            v-bind:Name="'BillingFax'"
                                            v-model="provider.billingFax"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_BillingFax'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.labInUrl')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="15"
                                            v-bind:Name="'LabInterfaceUrl'"
                                            v-model="provider.labInterfaceUrl"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'LabInterfaceUrl'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('providerSetup.signaturePad')"
                                            v-bind:Options="SignaturePadList"
                                            v-bind:FieldDescription="'name'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Model="provider.signaturePad"
                                            v-bind:Multiple="false"
                                            :IsDisabled="isReadOnly"
                                            :Input="ChangeDropDownSignaturePad"
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                            <div class="tab-pane fade" id="mpref" role="tabpanel">
                                <MdTitle
                                    v-bind:Text="$t('providerSetup.microsoftTeams')"
                                    v-bind:isSubtitle="true"
                                    v-bind:Name="'T_TitleSearch'"
                                />
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.msTeamTenant')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="255"
                                            v-bind:Name="'MSTeamTenant'"
                                            v-model="provider.msTeamTenant"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_MSTeamTenant'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Shared.ClientId')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="255"
                                            v-bind:Name="'msTeamClientId'"
                                            v-model="provider.msTeamClientId"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_msTeamClientId'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('PPDbSetup.ClientSecret')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="255"
                                            v-bind:Name="'msTeamClientSecret'"
                                            v-model="provider.msTeamClientSecret"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_msTeamClientSecret'"
                                        />
                                    </b-col>
                                    <b-col md="3">
                                        <MdCheckBox
                                            v-bind:Label="$t('providerSetup.addMeetingInOutlookCalendar')"
                                            v-bind:Name="'checkbox-adress'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="provider.msTeamUseCalendar"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="
                                                $t('providerSetup.syncAppo')
                                            "
                                            v-bind:Options="SyncAppList"
                                            v-bind:FieldDescription="'name'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Model="provider.enableExchangeSync"
                                            v-bind:Multiple="false"
                                            :Input="changeExchangeSync"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.eCaleUrl')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="255"
                                            v-bind:Name="'ExchangeWebServiceUrl'"
                                            v-model="provider.exchangeWebServiceUrl"
                                            v-bind:isReadOnly="isUrlReadOnly"
                                            v-bind:Id="'input_ExchangeWebServiceUrl'"
                                        />
                                    </b-col>
                                </b-row>
                                <MdTitle
                                    v-bind:Text="$t('Office 365')"
                                    v-bind:isSubtitle="true"
                                    v-bind:Name="'T_TitleSearch'"
                                />
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.appId')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="255"
                                            v-bind:Name="'Office365AppId'"
                                            v-model="provider.office365AppId"
                                            v-bind:isReadOnly="isUrlReadOnly"
                                            v-bind:Id="'input_Office365AppId'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.tenantId')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="255"
                                            v-bind:Name="'Office365TenantId'"
                                            v-model="provider.office365TenantId"
                                            v-bind:isReadOnly="isUrlReadOnly"
                                            v-bind:Id="'input_Office365TenantId'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('PPDbSetup.ClientSecret')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="255"
                                            v-bind:Name="'Office365ClientSecret'"
                                            v-model="provider.office365ClientSecret"
                                            v-bind:isReadOnly="isUrlReadOnly"
                                            v-bind:Id="'input_Office365ClientSecret'"
                                        />
                                    </b-col>
                                </b-row>
                                <MdTitle
                                    v-bind:Text="$t('providerSetup.teleHealth')"
                                    v-bind:isSubtitle="true"
                                    v-bind:Name="'T_TitleSearch'"
                                />
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdSelect
                                            v-bind:Label="$t('providerSetup.Platform')"
                                            v-bind:Options="PlatformList"
                                            v-bind:FieldDescription="'name'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:Model="provider.teleHealthPlatform"
                                            v-bind:Multiple="false"
                                            :IsDisabled="isReadOnly"
                                            :Input="ChangeDropDownPlatform"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('providerSetup.oMeetBrowser')"
                                            v-bind:Name="'checkbox-opm'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="provider.teleHealthOpenInBrowser"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.JitsiUrl')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="255"
                                            v-bind:Name="'TeleHealthUrl'"
                                            v-model="provider.teleHealthUrl"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_TeleHealthUrl'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.zToken')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="255"
                                            v-bind:Name="'ZoomToken'"
                                            v-model="provider.zoomToken"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_ZoomToken'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.zoomAccountId')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="500"
                                            v-bind:Name="'ZoomAccountId'"
                                            v-model="provider.zoomAccountId"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_ZoomAccountId'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('providerSetup.showProviderNameRightInReports')"
                                            v-bind:Name="'checkbox-showPR'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="provider.showProviderNameRightInReports"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.NpiRegistryUrl')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="500"
                                            v-bind:Name="'NpiRegistryUrl'"
                                            v-model="provider.npiRegistryUrl"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_NpiRegistryUrl'"
                                        />
                                    </b-col>
                                </b-row>
                                <MdTitle
                                    v-bind:Text="$t('providerSetup.tInformation')"
                                    v-bind:isSubtitle="true"
                                    v-bind:Name="'T_TitleSearch'"
                                />
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.twilioSMSSender')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="25"
                                            v-bind:Name="'TwilioSMSSender'"
                                            v-model="provider.twilioSMSSender"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_TwilioSMSSender'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.twilioWhatsAppSender')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="25"
                                            v-bind:Name="'TwilioWhatsAppSender'"
                                            v-model="provider.twilioWhatsAppSender"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:Id="'input_TwilioWhatsAppSender'"
                                        />
                                    </b-col>
                                </b-row>
                                <MdTitle
                                    v-bind:Text="''"
                                    v-bind:isSubtitle="true"
                                    v-bind:Name="'T_TitleSearch'"
                                />
                                <b-row>
                                    <b-col md="12" lg="12" sm="12">
                                        <MdCheckListBox2
                                            v-model="checkLists.MoreReferences.selected"
                                            v-bind:Options="checkLists.MoreReferences.options"
                                            v-bind:columnCount="4"
                                            v-bind:Tag="'MoreReferences'"
                                            :textField="'description'"
                                            :valueField="'code'"
                                            :ShowSearchInput="true"
                                            :ShowSelectAll="true"
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                            <!--                             
                            <div class="tab-pane fade" id="glexport" role="tabpanel">
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.Directory')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="100"
                                            v-bind:Name="'Glfiledir'"
                                            v-model="provider.glfiledir"
                                            v-bind:isReadOnly="isUrlReadOnly"
                                            @blur="checkDirectory"
                                            v-bind:Id="'input_Glfiledir'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.Extension')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="3"
                                            v-bind:Name="'Glfileext'"
                                            v-model="provider.glfileext"
                                            v-bind:isReadOnly="isUrlReadOnly"
                                            v-bind:Id="'input_Glfileext'"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('providerSetup.autoGenFileName')"
                                            v-bind:Name="'checkbox-Glautogenfilename'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="provider.glautogenfilename"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.defaultFileName')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="50"
                                            v-bind:Name="'Glexportfilename'"
                                            v-model="provider.glexportfilename"
                                            v-bind:isReadOnly="isUrlReadOnly"
                                            v-bind:Id="'input_Glexportfilename'"
                                        />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('providerSetup.AcctReceivable')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="20"
                                            v-bind:Name="'Glacctreceivable'"
                                            v-model="provider.glacctreceivable"
                                            v-bind:isReadOnly="isUrlReadOnly"
                                            v-bind:Id="'input_Glacctreceivable'"
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                            <div class="tab-pane fade" id="tranThe" role="tabpanel">
                                <b-row> 
                                    <b-col lg="3" md="3" sm="12">
                                        <MdLookup
                                            v-bind:ModelCode="provider.pickUpCpt"
                                            v-bind:ModelDescription="cptDescription"
                                            v-bind:Label="$t('providerSetup.PickUp')"
                                            v-bind:RefCode="'pickUpCpt'"                     
                                            v-bind:Api="'cpts'"
                                            v-bind:FieldCode="'code'"                    
                                            v-bind:FieldDescription="'name'"
                                            :GetValues="onCodeConditionOk"
                                            :SearchFieldCode="'code'"
                                        />
                                    </b-col>  
                                    <b-col lg="3" md="3" sm="12">
                                        <MdLookup
                                            v-bind:ModelCode="provider.dropOffCpt"
                                            v-bind:ModelDescription="offDescription"
                                            v-bind:Label="$t('providerSetup.DropOff')"
                                            v-bind:RefCode="'dropOffCpt'"                     
                                            v-bind:Api="'cpts'"
                                            v-bind:FieldCode="'code'"                    
                                            v-bind:FieldDescription="'name'"
                                            :GetValues="onCodeConditionOk"
                                            :SearchFieldCode="'code'"
                                        />
                                    </b-col> 
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col md="3">
                                        <MdCheckBox
                                            v-bind:Label="$t('providerSetup.useTherapies')"
                                            v-bind:Name="'checkbox-therapies'"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            @change="UseTherapies($event)"
                                            v-model="CheckTherapies"
                                            
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                             -->
                            <div class="tab-pane fade" id="logo" role="tabpanel">
                                <b-row>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdEdit
                                            v-bind:Label="$t('Layout.Homepage')"
                                            v-bind:TypeProp="'text'"
                                            v-bind:MaxLengthProp="20"
                                            v-bind:Name="'Homepage'"
                                            v-model="provider.homePage"
                                            v-bind:isReadOnly="isUrlReadOnly"
                                            v-bind:Id="'input_Homepage'"
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                            <div class="tab-pane fade" id="dm" role="tabpanel">
                                <b-row>
                                    <div class="col-sm-12 col-md-3">
                                        <MdButton
                                            v-bind:Label="$t('PatientDocument.AddDocument')"
                                            v-bind:ClassProp="
                                                isReadOnly
                                                    ? 'btn btn-primary my-3 btn-block'
                                                    : 'btn btn-primary my-3 btn-block btn-login'
                                            "
                                            v-bind:IconClass="'ti-plus pr-1'"
                                            v-on:click="CallModalDocumentMgr"
                                            v-bind:isReadOnly="this.isReadOnly"
                                        >
                                        </MdButton>
                                    </div>
                                    <div class="col-sm-12 col-md-9 mb-4">
                                        <div
                                            class="textlabel"
                                            :data-label="this.$t('Shared.SearchElements')"
                                        >
                                            <div class="input-group" dir="ltr">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    :dir="dirInput"
                                                    v-model="searchDocumentMgr"
                                                    @keyup.enter="FindDocumentMgr"
                                                />
                                                <div class="input-group-append">
                                                    <div class="input-group-append">
                                                        <MdButton
                                                            v-bind:Name="'btnsearchinputDocument'"
                                                            v-bind:VariantProp="
                                                                'btn btn-sm search-attached'
                                                            "
                                                            v-bind:IconClass="'mdi mdi-magnify'"
                                                            v-on:click="FindDocumentMgr"
                                                        >
                                                        </MdButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-row>
                                <div class="row">
                                    <div class="col-md-12">
                                        <MdTablePaginationClient
                                            v-bind:FieldsDate="FieldsDateDocumentMgr"
                                            v-bind:fields="fieldsDocumentMgr"
                                            v-bind:items="documentMgrCodesListFilter"
                                            v-bind:totalRows="totalRowsDocumentMgr"
                                            v-bind:isReadOnly="isReadOnly"
                                            v-bind:showMessageIsEmpty="
                                                showMessageIsEmptyDocumentMgr
                                            "
                                            v-bind:currentPage="currentPageDocumentMgr"
                                            v-bind:perPage="perPageDocumentMgr"
                                            v-bind:pageOptions="pageOptionsDocumentMgr"
                                            v-bind:IsItemReceived="false"
                                            :onRowSelected="onRowSelectedDocumentMgr"
                                            :onFiltered="onFilteredDocumentMgr"
                                            :pageChanged="pageChangedDocumentMgr"
                                            :perPageFunction="PerPageFunctionDocumentMgr"
                                            :VisibleDeleteIcon="true"
                                            :deleteIconEvent="RemoveDocumentMgr"
                                            :VisibleEditIcon="true"
                                            :editIconEvent="EditDocumentMgr"
                                            :RowClick="RowClick"
                                        >
                                        </MdTablePaginationClient>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </MdTabList>
                </b-col>
            </b-row>

            <div class="space-actions"></div>
            <div class="page-actions">
                <MdButton
                    v-bind:Label="$t('Shared.Back')"
                    v-bind:Name="'btnBack'"
                    v-bind:TextToolTip="$t('ePharmacyItemsReceived.BackToList')"
                    v-on:click="goBack"
                    v-bind:ClassProp="'mx-2 btn-login'"
                />
                <MdButton
                    v-bind:Label="$t('Shared.Save')"
                    v-bind:ClassProp="this.isReadOnly ? 'primary mx-2' : 'primary btn-login mx-2'"
                    v-on:click="SaveOrEdit"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Name="'btn_save_insurance_setup'"
                />
            </div>
        </div>

         <ProviderIdDocumentMgrModal
            :visible.sync="visibleDocumentMgrModal"
            v-model="editableDocumentMgr"
            :documentTypeList="documentTypeList"
            :editMode="editableItemMode"
            @ok="saveDocumentMgr"
        >
        </ProviderIdDocumentMgrModal>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import GlobalService from '@/services/global.service';
import { EventBus } from '@/event-bus.js';
import Permission from '@/common/Permission';
import ProviderService from '@/services/provider.service';
import PlaceOfServiceService from '@/services/placeofservice.service';
import CountryService from '@/services/country.service';
import StateService from '@/services/state.service';
import ProviderCodes from '@/services/providerCodes.service';
import CptService from '@/services/cpt.service';
import Utils from "@/common/utils";
import InsuranceService from '@/services/insurance.service';
import DocumentManagementService from '@/services/documentmanagement.service'
import ProviderPanel from './providerPanel.vue';
import ProviderIdDocumentMgrModal from './providerIdDocumentMgrModal.vue';
import DocumentTypeService from '@/services/documenttype.service';
import validator from 'validator';

let elemSaveBtn = '';
export default {
    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('insuranceSetup.iSetupTitle'),
                    okTitle: this.$t('Shared.Save'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (!value) {
                        next();
                    } else {
                        this.SaveOrEdit();
                        next();
                    }
                });
        } else {
            next();
        }
    },
    props: ['editMode'],
    mixins: [ShowMessage, DBFunctions, Permission],
    components: {
        ProviderPanel,
        ProviderIdDocumentMgrModal
    },
    name: 'ProviderSetup',
    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                Mode: this.editMode,
                favButtonAtion: false
            },
            ShowMessageIsEmpty: false,
            provider: {
                code: '',
                timeZone: null,
                documentMgrCodesList:[],
                providerCodesList:[]
            },
            insuranceZipChanged: false,

            TaxonomyList: [],
            ProviderCodes: [],
            tablist: [
                { title: this.$t('Shared.General'), link: '#general', active: true },
                { title: this.$t('Shared.Reference'), link: '#ref' },
                { title: this.$t('Shared.ProviderId'), link: '#provid' },
                { title: this.$t('UserPreferences.PrefTitle'), link: '#pref' },
                { title: this.$t('providerSetup.mPreferences'), link: '#mpref' },
                // { title: this.$t('providerSetup.gLExport'), link: '#glexport' },
                // { title: this.$t('providerSetup.tTherapies'), link: '#tranThe' },
                { title: this.$t('providerSetup.Logo'), link: '#logo' },
                { title: this.$t('employee.DocumentMgr'), link: '#dm' }
            ],

            isReadOnly: false,
            pendingChanges: false,
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            StateList: [],
            StateModel: { name: '', state: '' },
            CountryList: [],
            CountryModel: { recId: null, name: null },
            StatusOptions: [
                { name: this.$t('Shared.Active'), code: 'A' },
                { name: this.$t('providerSetup.Maintenance'), code: 'M' },
                { name: this.$t('providerSetup.Revoked'), code: 'R' }
            ],
            StatusModel: { name: this.$t('providerSetup.Revoked'), code: 'R' },
            PosDescription: '',
            taxonomyDescription: '',
            stateDescription: '',
            offDescription:'',
            cptDescription:'',
            BaseFieldsComm: [
                { key: 'code', sortable: true, label: this.$t('Shared.Code') },
                { key: 'description', sortable: true, label: this.$t('Shared.Description') }
            ],
            typeProv: [
                { name: 'CMHC', code: 'CMHC' },
                { name: 'IPF', code: 'IPF' }
            ],
            timeZoneList: [],
            isCountryUsa: true,
            slDescription: '',
            EditorList: [
                { name: 'MEDEZ', code: 'MEDEZ' },
                { name: 'MSWORD', code: 'MSWORD' }
            ],
            PlatformList: [
                { name: 'MSTeams', code: 'MSTeams' },
                { name: 'Jitsi', code: 'Jitsi' },
                { name: 'Zoom', code: 'Zoom' }
            ],
            SignaturePadList: [
                { name: 'Signotec', code: 'Signotec' },
                { name: 'Topaz', code: 'Topaz' }
            ],
            checkLists: {
                Reference: {
                    options: [
                        { code: 'prSignInd', description: this.$t('providerSetup.prSignInd') },
                        { code: 'isLineBilling', description: this.$t('providerSetup.isLineBilling') },
                        { code: 'canbypassdrivercheck', description: this.$t('providerSetup.canBypassDriverCheck') },
                        { code: 'canupdatescheduler', description: this.$t('providerSetup.canUpdateScheduler') },
                        { code: 'showDoctorName', description: this.$t('providerSetup.showDoctorName') },
                        { code: 'canCheckAll', description: this.$t('providerSetup.canCheckAll') },
                        { code: 'useNpi', description: this.$t('providerSetup.useNpi') },
                        { code: 'isMaster', description: this.$t('providerSetup.isMaster') },
                        { code: 'enforceRoomSchedule', description: this.$t('providerSetup.enforceRoomSchedule') },
                        { code: 'allowZeroChargeClaims', description: this.$t('providerSetup.allowZeroChargeClaims') },
                        { code: 'allowUnitPriceChanges', description: this.$t('providerSetup.allowUnitPriceChanges')},
                        { code: 'isSolo', description: this.$t('providerSetup.isSolo') },
                        { code: 'isTraining', description: this.$t('providerSetup.isTraining') },
                        { code: 'isMasterEntity', description: this.$t('providerSetup.isMasterEntity') },
                        { code: 'autoApplyCredit', description: this.$t('providerSetup.autoApplyCredit') }
                    ],
                    selected: []
                },

                MoreReferences: {
                    options: [
                        { code: 'showPatientPhoto', description: this.$t('providerSetup.showPatientPhoto') },
                        { code: 'printPatDiag', description: this.$t('providerSetup.printPatDiag') },
                        { code: 'hideHcPcsCode', description: this.$t('providerSetup.hideHcPcsCode') },
                        { code: 'useSchForNotes', description: this.$t('providerSetup.useSchForNotes') },
                        { code: 'isInterim',description: this.$t('providerSetup.isInterim') },
                        { code: 'allowMultipleAdmissions',description: this.$t('providerSetup.allowMultipleAdmissions')},
                        { code: 'showWristBand', description: this.$t('providerSetup.showWristBand') },
                        { code: 'emailEncounterRecepient', description: this.$t('providerSetup.emailEncounterRecepient')},
                        { code: 'updateProgScheduler', description: this.$t('providerSetup.updateProgScheduler') },
                        { code: 'isInOutPatient', description: this.$t('providerSetup.isInOutPatient') },
                        { code: 'showChat', description: this.$t('providerSetup.showChat') },
                        { code: 'labInterface', description: this.$t('providerSetup.labInterface') },
                        { code: 'enableOrders', description: this.$t('providerSetup.enableOrders') },
                        { code: 'useBlankDoctorCode', description: this.$t('providerSetup.useBlankDoctorCode') },
                        { code: 'enableNotifications', description: this.$t('providerSetup.enableNotifications') },
                        { code: 'byPassOverOvelappingTherapies', description: this.$t('providerSetup.byPassOverOvelappingTherapies')},
                        { code: 'webVersionEnabled', description: this.$t('providerSetup.webVersionEnabled') },
                        { code: 'useBranchLocations', description: this.$t('providerSetup.useBranchLocations') },
                        { code: 'enforcePatientLocation', description: this.$t('providerSetup.enforcePatientLocation')},
                        { code: 'canDeleteFutureAppts', description: this.$t('providerSetup.canDeleteFutureAppts')},
                        { code: 'restrictPatientInactivation', description: this.$t('providerSetup.restrictPatientInactivation')},
                        { code: 'useNewCrop', description: this.$t('providerSetup.useNewCrop') },
                        { code: 'allowNoDiagnosisOnAdmission', description: this.$t('providerSetup.allowNoDiagnosisOnAdmission')},
                        { code: 'checkDropOutAfterLogin', description: this.$t('providerSetup.checkDropOutAfterLogin')},
                        { code: 'useStudent', description: this.$t('providerSetup.useStudent') },
                        { code: 'enforcePatientFlowInEHR', description: this.$t('providerSetup.enforcePatientFlowInEHR')},
                        { code: 'enableAudit', description: this.$t('providerSetup.enableAudit') }
                    ],
                    selected: []
                }
            },
            SyncAppList: [
                { name: this.$t('None'), code: 'N' },
                { name: this.$t('Office 365'), code: 'O' },
                { name: this.$t('MS ExChange'), code: 'Y' }
            ],
            isUrlReadOnly: false,
            horizontalpositionOptions: [
                { value: 'L', text: this.$t('Left') },
                { value: 'R', text: this.$t('Right') }
            ],
            OfficeToolList: [
                { name: 'MicroSoft', code: 'MicroSoft' },
                { name: 'LibreOffice', code: 'LibreOffice' },
                { name: 'Office 365', code: 'Office 365' }
            ],
           
            search: {
                documentMgr: '',
            },
           
            editableItemIndex: -1,
          
            CheckTherapies:false,
            isEmailValid:true,
            insuranceList: [],
            searchDocumentMgr: '',
            currentPageDocumentMgr: 1,
            perPageDocumentMgr: 10,
            FieldsDateDocumentMgr: ['scanneddate', 'expiration'],
            fieldsDocumentMgr: [
                {
                    key: 'description',
                    sortable: true,
                    label: this.$t('PatientDocument.DocumentType'),
                    class: 'text-rigth'
                },
                {
                    key: 'scanneddate',
                    sortable: true,
                    label: this.$t('HouseFile.FileDate'),
                    class: 'text-rigth',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'expirationDate',
                    sortable: true,
                    label: this.$t('Shared.ExpirationDate'),
                    class: 'text-rigth',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'comments',
                    sortable: true,
                    label: this.$t('Shared.Comments'),
                    class: 'text-rigth'
                },
                {
                    key: 'fileName',
                    sortable: true,
                    label: this.$t('HouseFile.FileName'),
                    class: 'text-rigth'
                }
            ],
            editableItemMode: false,
            visibleDocumentMgrModal: false,
            pageOptionsDocumentMgr: [5, 10, 15],
            documentTypeList: [],
            editableDocumentMgr: {
                comments: '',
                description: '',
                doccode: '',
                entitycode: '',
                entitytype: '',
                expirationDate: null,
                extension: '',
                fileName: '',
                sysUser: null,
                IsNew: false,
                Image: ''
            },
        };
    },
    computed: {
        showMessageIsEmptyDocumentMgr() {
            return this.totalRowsDocument === 0;
        },

        documentMgrCodesListFilter() {
            const search = (this.search.documentMgr || '').trim().toLowerCase();
            const list = this.provider.documentMgrCodesList || [];

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.documentName || '').toLowerCase();
                const id = (item.comment || '').toLowerCase();

                return name.includes(search) || id.includes(search);
            });
        },

        totalRowsDocumentMgr() {
            return this.documentMgrCodesListFilter?.length || 0;
        },
    },
   
    methods: {
        insuranceZipChange: function() {
            this.insuranceZipChanged = true;
        },

        insuranceZipBlur: function(value) {
            if (this.insuranceZipChanged && value.trim() !== '') {
                GlobalService.getCityAndStateByZipCode(value)
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            var obj = response.data;
                            if (obj.city) {
                                this.$set(this.provider, 'city', obj.city);
                                this.$set(this.provider, 'state', obj.state);
                            }
                            this.insuranceZipChanged = false;
                        }
                    })
                    .catch(error => {
                        this.provider.city = '';
                        this.provider.state = '';
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        PrepareData() {
            const provCode = this.provider.code;
            const providerData = { ...this.provider };

            delete providerData.documentMgrCodesList;

            providerData.providerCodesList = providerData.providerCodesList.map(item => ({
                code: provCode,
                providerId: item.providerid,
                insCode: item.inscode
            }));

            return {
                providerData
            };
        },

        SaveOrEdit() {
            if (this.validate_entries()) {
                if (!this.isReadOnly) {
                    elemSaveBtn.setAttribute('disabled', '');

                    if (this.editMode) {
                        this.update();
                    } else {
                        this.save();
                    }
                }
            } else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.InvalidFieldValuesDetected'),
                    'errorAutoHide'
                );
            }
        },

        save() {
            // Primero actualizamos los campos provenientes de MdCheckListBox2
            this.applyCheckListsToProvider();
            const { providerData } = this.PrepareData();
            const dataToSend = this.convertBoolToYN(providerData);

            ProviderService.add(dataToSend)
                .then(async response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        // Llamamos a insertProviderDoc después de guardar exitosamente
                        await this.insertProviderDoc();
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );

                        this.goBack();
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        update() {
            // Primero actualizamos los campos provenientes de MdCheckListBox2
            this.applyCheckListsToProvider();
            const { providerData } = this.PrepareData();
            const dataToSend = this.convertBoolToYN(providerData);
        
            ProviderService.update(this.$route.params.id, dataToSend)
                .then(async response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        // Llamamos a updateProviderDoc después de guardar exitosamente
                        await this.updateProviderDoc();
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );

                        this.goBack();
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        async getProvider() {
            if (this.editMode) {
                try {
                    const response = await ProviderService.get(this.$route.params.id);

                    if (response.status == '200' && response.data) {
                        // PRIMERO convertir Y/N a booleanos
                        this.provider = this.convertYNObj(response.data);
                        this.loadCheckListsFromDb(this.provider);

                        this.CountryModel.code = this.provider?.country || '';
                        this.CountryModel.name = this.provider?.country || '';

                        this.isCountryUsa = this.CountryModel.name != 'United States' ? false : true;
                    }
                } catch (error) {
                    this.showResponseErrorMessage(error);
                }
            }
        },
        // Método auxiliar para convertir Y/N a booleanos
        convertYNObj(obj) {
            if (typeof obj !== 'object' || obj === null) return obj;

            if (Array.isArray(obj)) {
                return obj.map(item => this.convertYNObj(item));
            }

            const result = {};
            for (const [key, value] of Object.entries(obj)) {
                if (key !== 'enableExchangeSync' && typeof value === 'string' && value === 'Y') {
                    result[key] = true;
                } else if (key !== 'enableExchangeSync' && typeof value === 'string' && value === 'N') {
                    result[key] = false;
                } else if (typeof value === 'object' && value !== null) {
                    result[key] = this.convertYNObj(value);
                } else {
                    result[key] = value;
                }
            }
            return result;
        },

        // Convertir booleanos a "Y"/"N"
        convertBoolToYN(obj) {
            if (typeof obj !== 'object' || obj === null) return obj;

            if (Array.isArray(obj)) {
                return obj.map(item => this.convertBoolToYN(item));
            }

            const result = {};
            for (const [key, value] of Object.entries(obj)) {
                // SOLO transforma si es booleano Y NO es status
                if (typeof value === 'boolean') {
                    // ← Cambiado a else if
                    result[key] = value ? 'Y' : 'N';
                }
                // Si es un objeto (no null), lo procesa recursivamente
                else if (typeof value === 'object' && value !== null) {
                    result[key] = this.convertBoolToYN(value);
                }
                // CUALQUIER OTRO VALOR lo deja igual
                else {
                    result[key] = value;
                }
            }
            return result;
        },

        onCodeConditionOk(result) {
            if (!this.provider) return;

            const type = result.FieldName;
            const { code, description } = result;

            const mapping = {
                posCode: { codeProp: 'posCode', descProp: 'PosDescription' },
                taxonomy: { codeProp: 'taxonomy', descProp: 'taxonomyDescription' },
                serviceLocation: { codeProp: 'serviceLocation', descProp: 'slDescription' },
                state: { codeProp: 'billingState', descProp: 'stateDescription' },
                pickUpCpt: { codeProp: 'pickUpCpt', descProp: 'cptDescription' },
                dropOffCpt: { codeProp: 'dropOffCpt', descProp: 'offDescription' }
            };

            const key = Object.keys(mapping).find(k => type.includes(k));

            if (key) {
                const { codeProp, descProp } = mapping[key];
                this.provider[codeProp] = code || '';
                this[descProp] = description || '';
            }
        },

        async getAllDescription() {
            if (!this.provider) return;

            const getters = {
                posCode: {
                    codes: [this.provider.posCode],
                    fetch: async code => {
                        const parameter = { code: code };
                        const response = await PlaceOfServiceService.getPlaceOfServiceByCode(
                            parameter
                        );
                        return response?.data?.[0]?.description || '';
                    },
                    setter: value => {
                        this.PosDescription = value;
                    }
                },
                taxonomy: {
                    codes: [this.provider.taxonomy],
                    fetch: async code => {
                        const response = await GlobalService.getTaxonomyType(code);
                        return response?.data?.[0]?.description || '';
                    },
                    setter: value => {
                        this.taxonomyDescription = value;
                    }
                },
                serviceLocation: {
                    codes: [this.provider.serviceLocation],
                    fetch: async code => {
                        const parameter = { code: code, PageSize: 0, PageNumber: 0 };
                        const response = await ProviderCodes.getHealthcareServiceLocation(
                            parameter
                        );
                        return response?.data?.[0]?.description || '';
                    },
                    setter: value => {
                        this.slDescription = value;
                    }
                },
                state: {
                    codes: [this.provider.billingState],
                    fetch: async code => {
                        const response = await StateService.get(code);
                        return response?.data?.name || '';
                    },
                    setter: value => {
                        this.stateDescription = value;
                    }
                },
                pickUpCpt: {
                    codes: [this.provider.pickUpCpt],
                    fetch: async code => {
                        const parameter = { code: code };
                        const response = await CptService.getCPTByCode(parameter);
                        return response?.data?.[0]?.name || '';
                    },
                    setter: value => {
                        this.cptDescription = value;
                    }
                },
                dropOffCpt: {
                    codes: [this.provider.dropOffCpt],
                    fetch: async code => {
                        const parameter = { code: code };
                        const response = await CptService.getCPTByCode(parameter);
                        return response?.data?.[0]?.name || '';
                    },
                    setter: value => {
                        this.offDescription = value;
                    }
                }
            };
            
            // Ejecutar todas las peticiones en paralelo
            await Promise.allSettled(
                Object.values(getters).flatMap(({ codes, fetch, setter }) =>
                    codes.filter(Boolean).map(async code => {
                        try {
                            const value = await fetch(code);
                            if (value) setter(value);
                        } catch (error) {
                              console.log(error)
                            this.showResponseErrorMessage(error);
                        }
                    })
                )
            );
        },

        goBack() {
            this.checkExistFavorite('/app/providerlist');
            this.$router.push({ name: 'ProviderListing' });
        },

        validate_entries() {
            this.isEmailValid =
                this.provider.email == '' || this.provider.email == null ? true : false;

            this.isEmailValid =
                Utils.isNullOrEmptyString(this.provider.email) ||
                validator.isEmail(this.provider.email);

            return this.isEmailValid;
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        },

        checkUserAction() {
            if (elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        },

        async ExecuteAllCalls() {
            await this.getTimeZone();
            await this.getProvider();
            await this.getInsurances();
            await this.getDocumentType();
            await this.getProviderDoc();
        },

        ChangeDropDownStatus(item) {
            this.provider.status = item?.code;
            this.StatusModel = item;
        },

        ChangeDropDownType(item) {
            this.provider.types = item?.code;
        },

        ChangeDropDownZone(item) {
            this.provider.timeZone = item?.recId;
        },

        getOnlyCountry(arr){
            let temp = [];
            arr.forEach(element => {
                temp.push({code:element.name, name:element.name,recId:element.recId});
            });
            return temp;
        },

        async populateSelects() {
            if (this.$store.state.statewasloaded) {
                this.StateList = this.$store.state.StateList;
            } else {
                await StateService.getAll()
                    .then((response) => {
                        if (response.status == '200') {
                            this.StateList = response.data;
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'), error, "error");
                        }
                    });
            }

            if (this.$store.state.countrywasloaded) {
                this.CountryList = this.getOnlyCountry(this.$store.state.CountryList);
            } else {
                await CountryService.getCountries()
                    .then((response) => {
                        if (response.status == '200') {
                            this.CountryList = this.getOnlyCountry(response.data);
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'), error, "error");
                        }
                    });
            }
        },

        ChangeDropDownCountry(item) {
            this.CountryModel = item ? item : { recId: '', name: '' };
            this.provider.country = this.CountryModel.name;
            this.isCountryUsa = this.CountryModel?.name != 'United States' ? false : true;
        },

        ChangeDropDownState(item) {
            this.provider.state = item ? item.state : null;
        },

        ChangeDropDownEditor(item) {
            this.provider.editorType = item ? item.code : null;
        },

        ChangeDropDownPlatform(item) {
            this.provider.teleHealthPlatform = item ? item.code : null;
        },

        ChangeDropDownSignaturePad(item) {
            this.provider.signaturePad = item ? item.code : null;
        },

        ChangeDropDownOfficeTool(item) {
            this.provider.officeTool = item ? item.code : null;
        },

        async getTimeZone() {
            const parameter = { PageSize: 0, PageNumber: 0 };
            await ProviderCodes.getTimeZone(parameter)
                .then(response => {
                    if (response.status == '200') {
                        this.timeZoneList = response.data;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        changeExchangeSync(item) {
            if (!item) return;
            const code = item.code;
            this.provider.enableExchangeSync = code;
            this.provider.exchangeWebServiceUrl = '';

            this.isUrlReadOnly = false;
            if (code == 'N') {
                this.isUrlReadOnly = true;
            }
        },
       
        loadCheckListsFromDb(data) {
            Object.keys(this.checkLists).forEach(tag => {
                const checkList = this.checkLists[tag];
                checkList.selected = checkList.options
                    .filter(option => data[option.code] === true)
                    .map(option => option.code);

            });
        },

        applyCheckListsToProvider() {
            Object.keys(this.checkLists).forEach(tag => {
                const checkList = this.checkLists[tag];
                const selected = new Set(checkList.selected || []);
                checkList.options.forEach(option => {
                    this.provider[option.code] = selected.has(option.code);
                });
            });
        },

        checkDirectory() {
            const ruta = this.provider.glfiledir.trim();

            // Validar formato según sistema operativo
            if (this.esWindows()) {
                this.validarRutaWindows(ruta);
            } else {
                this.validarRutaUnix(ruta);
            }
        },

        esWindows() {
            return navigator.platform.indexOf('Win') !== -1;
        },

        validarRutaWindows(ruta) {
            // Validar formato Windows: C:\carpeta\subcarpeta
            const regexWindows = /^[a-zA-Z]:\\(?:[^\\/:*?"<>|\r\n]+\\)*[^\\/:*?"<>|\r\n]*$/;
            if (!regexWindows.test(ruta)) {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    `${ruta} ${this.$t('Shared.InvalidWindowsPath')}`,
                    'errorAutoHide'
                );
            } else {
                // Validar existencia del directorio en el servidor
                ProviderService.checkDirectory(ruta)
                    .then(response => {
                        if (response.status === 200 && !response.data.exists) {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                `${ruta} ${this.$t('Shared.DirectoryDoesNotExist')}`,
                                'errorAutoHide'
                            );
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        validarRutaUnix(ruta) {
            // Validar formato Unix/Linux/Mac: /home/usuario/carpeta
            const regexUnix = /^\/(?:[^/\0]+\/)*[^/\0]*$/;
            
            if (!regexUnix.test(ruta)) {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    `${ruta} ${this.$t('Shared.InvalidUnixPath')}`,
                    'errorAutoHide'
                );
            } else {
                // Validar existencia del directorio en el servidor
                ProviderService.checkDirectory(ruta)
                    .then(response => {
                        if (response.status === 200 && !response.data.exists) {
                            this.showMessage(
                                this.$tc('Msg.Error'),
                                `${ruta} ${this.$t('Shared.DirectoryDoesNotExist')}`,
                                'errorAutoHide'
                            );
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        async UseTherapies(event) {
            this.CheckTherapies = event;
            console.log('UseTherapies changed:', this.CheckTherapies);
            if (this.CheckTherapies) {
                console.log('CheckTherapies is true, fetching therapy billing codes...');
            }
        },

        async getInsurances() {
            await InsuranceService.getAllInsurances({})
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.insuranceList = response.data.map(value => ({
                            code: value.insurancecode,
                            description: value.company
                        }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        FindDocumentMgr() {
            this.search.documentMgr = this.searchDocumentMgr;
            this.currentPageDocumentMgr = 1;
        },

        PerPageFunctionDocumentMgr(value) {
            this.perPageDocumentMgr = value;

            if (this.currentPageDocumentMgr > this.totalRowsDocumentMgr / this.perPageDocumentMgr) {
                this.currentPageDocumentMgr = 1;
            }
        },

        pageChangedDocumentMgr(value) {
            this.perPageDocumentMgr = value;
        },

        RemoveDocumentMgr(itemToRemove) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_document'
                })
                .then(value => {
                    if (value) {
                        const index = this.provider.documentMgrCodesList.findIndex(
                            item => item === itemToRemove
                        );

                        if (index !== -1) {
                            this.provider.documentMgrCodesList.splice(index, 1);
                            this.emitChanged('documentMgr');

                            if (
                                this.currentPageDocumentMgr >
                                this.totalRowsDocumentMgr / this.perPageDocumentMgr
                            ) {
                                this.currentPageDocumentMgr--;
                            }
                        }
                    }
                });
        },

        EditDocumentMgr(value) {
            this.editableItemMode = true;
            this.editableDocumentMgr = value;
            this.visibleDocumentMgrModal = true;
        },

        saveDocumentMgr(value) {
            if (!this.editableItemMode) {
                this.provider.documentMgrCodesList.push(...value);
            } else {
                const index = this.provider.documentMgrCodesList.findIndex(
                    item => item.seqno === this.editableDocumentMgr.seqno
                );

                if (index !== -1) {
                    this.provider.documentMgrCodesList.splice(index, 1);
                }

                const insertIndex =
                    index !== -1 ? index : this.provider.documentMgrCodesList.length;
                this.provider.documentMgrCodesList.splice(insertIndex, 0, ...value);
            }

            this.emitChanged('documentMgr');
        },

        CallModalDocumentMgr() {
            this.editableDocumentMgr = {
                comments: '',
                description: '',
                doccode: '',
                entitycode: '',
                entitytype: '',
                expirationDate: null,
                extension: '',
                fileName: '',
                scanneddate: null,
                seqno: null,
                sysUser: null,
                IsNew: false,
                Image: ''
            };
            this.editableItemMode = false;
            this.visibleDocumentMgrModal = true;
        },

        onRowSelectedDocumentMgr() {},

        onFilteredDocumentMgr() {},

        RowClick() {},

        async updateProviderDoc() {
            try {
                const provCode = this.provider.code;
                const documentMgrCodesList = this.provider.documentMgrCodesList.map(item => ({
                    ...item,
                    entitycode: provCode
                }));

                const entityType = 'E'; 
                let data = {
                    request: documentMgrCodesList 
                };
  
                const response = await DocumentManagementService.UpdateRange(provCode, entityType, data);
                
                if (response.status == '200') {
                    return response;
                }
            } catch (error) {
                if (error.response) {
                    this.showMessage(this.$tc('Msg.Error'), error, 'error');
                }
                throw error;
            }
        },

        async insertProviderDoc() {
            try {
                const provCode = this.provider.code;
                const documentMgrCodesList = this.provider.documentMgrCodesList.map(item => ({
                    ...item,
                    entitycode: provCode
                }));

                let data = {
                    request: documentMgrCodesList 
                };
  
                const response = await DocumentManagementService.Add(data);
                
                if (response.status == '200') {
                    return response;
                }
            } catch (error) {
                if (error.response) {
                    this.showMessage(this.$tc('Msg.Error'), error, 'error');
                }
                throw error;
            }
        },

        async getProviderDoc() {
            if (!this.provider?.code) return;
            
            const parameter = { EntityCode: this.provider.code, EntityType: 'E' };
            try {
                const response = await DocumentManagementService.getAll(parameter);
                if (response.status == '200' && response.data) {
                    this.provider.documentMgrCodesList = response.data.map(document => ({
                        IsNew: false,
                        Image: Utils.getType(document.extension),
                        comments: document.comments,
                        description: document.description,
                        doccode: document.doccode,
                        entitycode: document.entitycode,
                        entitytype: document.entitytype,
                        expirationDate: document.expirationDateDocument,
                        extension: document.extension,
                        fileName: document.fileName,
                        sysUser: document.sysUser,
                        scanneddate: document.scanneddate,
                        contents: document.contents,
                        seqno: document.seqno
                    }));
                }
            } catch (error) {
                if (error.response) {
                    this.showMessage(this.$tc('Msg.Error'), error, 'error');
                }
            }
        },

        async getDocumentType() {
            await DocumentTypeService.getAll({})
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.documentTypeList = response.data.map(value => ({
                            code: value.code,
                            description: value.description
                        }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        emitChanged(componentName) {
            const changed = {
                Changed: true,
                ComponentName: componentName
            };

            EventBus.$emit('onChanged', changed);
        },
    },

    async mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        const allPromise = Promise.all([await this.ExecuteAllCalls()]);
        await allPromise.then(() => {
            this.getAllDescription();
            this.populateSelects();
        });

        setTimeout(
            function() {
                elemSaveBtn = document.getElementById('btn_save_insurance_setup');
                elemSaveBtn.setAttribute('disabled', '');
            },
            50,
            this
        );
    },

    created() {
        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges = e.Changed;
                this.checkUserAction();
            }.bind(this)
        );
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy() {
        EventBus.$off('onChanged');
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
    }
};
</script>
